// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__S1AtR","topBottomGutter":"Layout_topBottomGutter__1WL-H"};